import Rate from './Rate';
export default Rate;


//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/rc-rate/es/index.js
// module id = 675
// module chunks = 0